/*!
  =========================================================
  * Muse Ant Design Dashboard - v1.0.0
  =========================================================
  * Product Page: https://www.creative-tim.com/product/muse-ant-design-dashboard
  * Copyright 2021 Creative Tim (https://www.creative-tim.com)
  * Licensed under MIT (https://github.com/creativetimofficial/muse-ant-design-dashboard/blob/main/LICENSE.md)
  * Coded by Creative Tim
  =========================================================
  * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import ReactApexChart from "react-apexcharts";
import { Typography } from "antd";
import { MinusOutlined } from "@ant-design/icons";
import lineChart from "./configs/lineChart";
import { useEffect, useState } from "react";
function LineChart({ data }) {
  const { Title, Paragraph } = Typography;
  // const [report, setReport] = useState({
  //   "orderOfToday": data?.orderOfToday,
  //   "orderOfMonth": data?.orderOfMonth,
  //   "orderOfWeek": data?.orderOfWeek,
  //   "orderOfPreviousDay": data?.orderOfPreviousDay,
  //   "orderOfPreviousWeek": data?.orderOfPreviousWeek,
  //   "orderOfPreviousMonth": data?.orderOfPreviousMonth,
  // });

  const percentWeek = (data?.orderOfWeek - data?.orderOfPreviousWeek) / data?.orderOfPreviousWeek * 100;

  // useEffect(() => {
  //   setReport({});
  // }, [data]);


  return (
    <>
      <div className="linechart">
        <div>
          <Title level={5}>Thống kê đơn hàng</Title>
          <Paragraph className="lastweek">
            so với tuần trước <span className="bnb2">+{percentWeek || 0}%</span>
          </Paragraph>
        </div>
        <div className="sales">
          <ul>
            {/* <li>{<MinusOutlined />} Traffic</li> */}
            <li>{<MinusOutlined />} <small>Đơn hàng</small></li>
          </ul>
        </div>
      </div>

      <ReactApexChart
        className="full-width"
        options={lineChart.options}
        series={[
          {
            name: "Số đơn hàng",
            data: [data?.orderOfPreviousDay,
            data?.orderOfToday,
            data?.orderOfPreviousWeek,
            data?.orderOfWeek,
            data?.orderOfPreviousMonth,
            data?.orderOfMonth],
            offsetY: 0,
          },
        ]}
        type="area"
        height={350}
        width={"100%"}
      />
    </>
  );
}

export default LineChart;
